import common from "./en/common";

export default {
    common,
};
